import { useEffect, useState } from "react";
import useApi from "../Api";
import { List, ListItem, ListItemText, Paper } from "@mui/material";

type MinecraftUser = { name: string; uuid: string };

const Users: React.FC = () => {
  const { get } = useApi();
  const [users, setUsers] = useState<MinecraftUser[]>([]);

  useEffect(() => {
    get<{ minecraftUsers: MinecraftUser[] }>("minecraft-users").then(
      ({ minecraftUsers }) => setUsers(minecraftUsers)
    );
  }, [get]);

  return (
    <List>
      {users.map((user) => (
        <ListItem key={user.uuid}>
          <ListItemText
            primary={user.name}
            secondary={user.uuid}
            slotProps={{ secondary: { sx: { fontFamily: "monospace" } } }}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default Users;
